//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pickJobGrpBatches', {
//        templateUrl: 'views/components/views/pickJobGrpBatches/pickJobGrpBatches.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'translateService', 'modalService', 'pickJobGrpBatchesService', 'logisticService', 'ttGridFactory', function (stateService, utilityService, translateService, modalService, pickJobGrpBatchesService, logisticService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                pickJobGroupButtons: [{ id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.pickjobgrp_keyno = '0' }],
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                selectListPickJobGroups: [],
//                updating: false,
//                lockedCreate: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await pickJobGrpBatchesService.getPickJobGroupBatches())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                return vm.model.selectListStockPlaces = await pickJobGrpBatchesService.listStockPlaces({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadPickJobGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                const list = await pickJobGrpBatchesService.listPickJobGroups({
//                    stockplace_id: vm.model.setting.stockplace_id,
//                    add_all: '1'
//                });

//                vm.model.setting.pickjobgrp_keyno = '0';
//                vm.model.selectListPickJobGroups = list;
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.deliverydate) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.pickjobgrp_keyno, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.show_finished_stocktransfers, true) !== true) return;

//                vm.grid.dataTask.loadData = {
//                    method: vm.model.setting.p2_datatask_keyno,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        loadStockPlaces();
//                        break;
//                    case 'stockplace_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                        vm.model.setting.stockplace_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                        Promise.all([
//                            loadPickJobGroups()
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'show_finished_stocktransfers':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.show_finished_stocktransfers) !== true) return;

//                        vm.model.setting.show_finished_stocktransfers = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.show_finished_stocktransfers) !== true) return;

//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON REFRESH PROCEDURE FUNCTION CALL

//            vm.updateChanges = function () {
//                vm.model.updating = true;

//                pickJobGrpBatchesService.updateObj(vm.model.setting).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.updating = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.updating = false;
//                    }
//                });
//            }

//            // #endregion BUTTON REFRESH PROCEDURE FUNCTION CALL

//            // #region BUTTON CREATE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.lockedCreate = true;

//                pickJobGrpBatchesService.createObj(vm.model.setting).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedCreate = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedCreate = false;
//                        loadGrid();
//                    }
//                });
//            }

//            // #endregion BUTTON CREATE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadCompanies();

//                return Promise.all([
//                    loadStockPlaces(),
//                    loadPickJobGroups(),
//                ]).then(() => {
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
